import React from "react"
import styled from "styled-components"
import { LargeHeightButton } from "../../common/Buttons"
import LoadInView from "../../common/LoadInView"
import { useNavigate } from "react-router-dom"

const UserCard = () => {
  const navigate = useNavigate()
  const handleClick = () => {
    navigate("/quiz/result")
  }

  return (
    <Container>
      <LoadInView>
        <ButtonGridContainer>
          <LargeHeightButton
            $bgColor="#4a4a4a"
            $borderColor="none"
            $hoverColor="#aaaaaa"
            $activeColor="#4a4a4a"
            onClick={handleClick}
          >
            검사결과1
            <div className="desc">검사일시: 23.10.01</div>
          </LargeHeightButton>
          <LargeHeightButton
            $bgColor="#4a4a4a"
            $borderColor="none"
            $hoverColor="#aaaaaa"
            $activeColor="#4a4a4a"
            onClick={handleClick}
          >
            검사결과2
            <div className="desc">검사일시: 23.10.02</div>
          </LargeHeightButton>
        </ButtonGridContainer>
      </LoadInView>
    </Container>
  )
}

export default UserCard

const Container = styled.div`
  max-width: 1280px;
  margin: 20px auto;
`

const ButtonGridContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px 50px;
`
